/**
 * @package dto
 * @author Vladimir Staadnik <x-doggy@ya.ru>
 * @class EditUserData
 */
import { UserName } from '@/modules/backend/Entities/UserName';
import { AbstractData } from '@/modules/backend/Dto/AbstractData';

export class EditUserData extends AbstractData {
  public id!: number;
  public name?: UserName;
  public email?: string;
  public companyIds?: number[];
  public roleIds?: number[];
  public providerIds?: number[];
}
